let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("Xr1bk")).then(() => parcelRequire('eQs1M'));